import { render, staticRenderFns } from "./SithMomMainProjectTemplateList.vue?vue&type=template&id=2de06480&"
import script from "./SithMomMainProjectTemplateList.vue?vue&type=script&lang=js&"
export * from "./SithMomMainProjectTemplateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports